import { aggregationFns } from '@tanstack/react-table';

export const MRT_AggregationFns = { ...aggregationFns };
